import React, { Component } from 'react'
import './css/AcademyPage.css'
import Packages from './Packages'
import FinancialFreedom from './FinancialFreedom';
import Knowledge from './Knowledge'
import Mentees from './Mentees'
import Building from './Building'
import Layout from "../../components/Layout"
import Join from "./Join"
import Learning from "./Learning"

class AcademyPage extends Component {
    render() {
        return (
            <Layout {...this.props}>
                <div className="academyPage">
                    <FinancialFreedom />
                    <Knowledge />
                    <Mentees />
                    <Building />
                    <Learning />
                    <Join />
                    <Packages />
                    
                </div>
            </Layout>
        )
    }
}

export default AcademyPage;